/*! js-cookie v3.0.5 | MIT */
!function(e,t){"object"==typeof exports&&"undefined"!=typeof module?module.exports=t():"function"==typeof define&&define.amd?define(t):(e="undefined"!=typeof globalThis?globalThis:e||self,function(){var n=e.Cookies,o=e.Cookies=t();o.noConflict=function(){return e.Cookies=n,o}}())}(this,(function(){"use strict";function e(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var o in n)e[o]=n[o]}return e}var t=function t(n,o){function r(t,r,i){if("undefined"!=typeof document){"number"==typeof(i=e({},o,i)).expires&&(i.expires=new Date(Date.now()+864e5*i.expires)),i.expires&&(i.expires=i.expires.toUTCString()),t=encodeURIComponent(t).replace(/%(2[346B]|5E|60|7C)/g,decodeURIComponent).replace(/[()]/g,escape);var c="";for(var u in i)i[u]&&(c+="; "+u,!0!==i[u]&&(c+="="+i[u].split(";")[0]));return document.cookie=t+"="+n.write(r,t)+c}}return Object.create({set:r,get:function(e){if("undefined"!=typeof document&&(!arguments.length||e)){for(var t=document.cookie?document.cookie.split("; "):[],o={},r=0;r<t.length;r++){var i=t[r].split("="),c=i.slice(1).join("=");try{var u=decodeURIComponent(i[0]);if(o[u]=n.read(c,u),e===u)break}catch(e){}}return e?o[e]:o}},remove:function(t,n){r(t,"",e({},n,{expires:-1}))},withAttributes:function(n){return t(this.converter,e({},this.attributes,n))},withConverter:function(n){return t(e({},this.converter,n),this.attributes)}},{attributes:{value:Object.freeze(o)},converter:{value:Object.freeze(n)}})}({read:function(e){return'"'===e[0]&&(e=e.slice(1,-1)),e.replace(/(%[\dA-F]{2})+/gi,decodeURIComponent)},write:function(e){return encodeURIComponent(e).replace(/%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g,decodeURIComponent)}},{path:"/"});return t}));

jQuery(document).ready(function($) {


	// Format values
	function captrustFormat(value) {
		value = value.replaceAll('-', ' ');
		value = value.replace(/(^|\s)[a-z]/gi, l => l.toUpperCase());
		return value;
	}


	// ===== CONSENT CHECK FUNCTION - NEW =====
	/**
	 * Check if user has granted tracking consent via TrustArc
	 * @returns {boolean}
	 */
	function hasTrackingConsent() {
		const trustarc = Cookies.get('cmapi_cookie_privacy');
		
		if (!trustarc) {
			// No consent cookie yet - user hasn't responded
			return false;
		}
		
		// Check for Analytics (Category 2) OR Advertising (Category 3)
		// Cookie format: "permit 1|2|3_" (pipe-separated with trailing underscore)
		const hasAnalytics = trustarc.includes('permit') && trustarc.includes('2');
		const hasAdvertising = trustarc.includes('permit') && trustarc.includes('3');
		
		return hasAnalytics || hasAdvertising;
	}
	// ===== END NEW FUNCTION =====


	// Set tracking cookies based on url parameters when user enters the site
	function captrustTracking() {
		
		// Store query parameters first (needed for GCLID which doesn't require consent)
		var tracking = [], hash;
		var hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
		for (var i = 0; i < hashes.length; i++) {
			hash = hashes[i].split('=');
			tracking.push(hash[0]);
			tracking[hash[0]] = hash[1];
		}

		// ===== GCLID CAPTURE - RUNS WITHOUT CONSENT =====
		// GCLID uses localStorage (not cookies) and is considered necessary for website functionality
		// Per Google's guidance, this can run before consent is granted
		// https://support.google.com/google-ads/answer/7012522
		if (tracking.gclid) {
			var gclsrc = tracking.gclsrc;
			// Validate gclsrc - must be absent or contain 'aw' for Google Ads
			var isGclsrcValid = !gclsrc || gclsrc.indexOf('aw') !== -1;
			
			if (isGclsrcValid) {
				var gclidRecord = {
					value: tracking.gclid,  // Store exact value - no formatting!
					expiryDate: new Date().getTime() + (90 * 24 * 60 * 60 * 1000) // 90 days in milliseconds
				};
				localStorage.setItem('gclid', JSON.stringify(gclidRecord));
				console.log('[Captrust Tracking] GCLID stored in localStorage:', tracking.gclid);
			}
		}
		// ===== END GCLID CAPTURE =====

		// ===== CONSENT CHECK FOR COOKIES =====
		// All cookie-based tracking requires consent
		if (!hasTrackingConsent()) {
			console.log('[Captrust Tracking] Consent not granted - skipping cookie-based tracking');
			return; // Exit early - don't set any cookies
		}
		console.log('[Captrust Tracking] Consent granted - initializing cookie-based tracking');
		// ===== END CONSENT CHECK =====

		/**
		 * Emails, paid ads, etc will be adding a "user_audience" URL parameter. This is being mapped
		 * to the 3 different client audience types. This will be used to prioritize certain content,
		 * display things differently depending on which audience the user has been identified as.
		 */
		if (tracking.user_audience) {
			// NO_CACHE cookie for Pantheon
			Cookies.set('NO_CACHE', 1, { expires: 7 });
			// Convert to lowercase
			tracking.user_audience = tracking.user_audience.toLowerCase();
			// Assign UTM Source to Cookie
			var visitor = {
				version: '1',
				userAudience: '',
				userAudienceDetailed: '',
				updatedAt: Date.now(),
			};
			// {"version":"1","userAudience":"individuals","userAudienceDetailed":"individual","updatedAt":1751481807}
			switch(tracking.user_audience) {
				case 'endowments':
				case 'nonprofits':
					visitor.userAudience = 'endowments';
					break;
				case 'individuals':
				case 'wealth':
					visitor.userAudience = 'individuals';
					break;
				case 'retirement':
					visitor.userAudience = 'retirement';
					break;
			}
			if (visitor.userAudience) {
				Cookies.set('wordpress_captrust_visitor', window.btoa(JSON.stringify(visitor)), { expires: 90 });
			}
		}

		// Microsoft Click ID
		if (tracking.msclkid) {
			Cookies.set('wordpress_captrust_msclkid', tracking.msclkid, { expires: 7 });
		}
			
		// UTM Source
		if (tracking.utm_source) {
			// NO_CACHE cookie for Pantheon
			Cookies.set('NO_CACHE', 1, { expires: 7 });
			// Convert to lowercase
			tracking.utm_source = tracking.utm_source.toLowerCase();
			// Assign UTM Source to Cookie
			switch(tracking.utm_source) {
				case 'bing':
					Cookies.set('wordpress_captrust_utm_source', 'Bing', { expires: 7 });
					break;
				case 'clickdimensions':
					Cookies.set('wordpress_captrust_utm_source', 'ClickDimensions', { expires: 7 });
					break;
				case 'facebook':
					Cookies.set('wordpress_captrust_utm_source', 'Facebook', { expires: 7 });
					break;
				case 'google':
					Cookies.set('wordpress_captrust_utm_source', 'Google', { expires: 7 });
					break;
				case 'linkedin':
					Cookies.set('wordpress_captrust_utm_source', 'LinkedIn', { expires: 7 });
					break;
				case 'microsoft':
					Cookies.set('wordpress_captrust_utm_source', 'Microsoft', { expires: 7 });
					break;
				default:
					Cookies.set('wordpress_captrust_utm_source', 'Google', { expires: 7 });
					break;
			}
		}
		
		// UTM Medium
		if (tracking.utm_medium) {
			// Convert to lowercase
			tracking.utm_medium = tracking.utm_medium.toLowerCase();
			// Assign UTM Medium to Cookie
			switch(tracking.utm_medium) {
				case 'discovery':
					Cookies.set('wordpress_captrust_utm_medium', 'Discovery', { expires: 7 });
					break;
				case 'display':
					Cookies.set('wordpress_captrust_utm_medium', 'Display', { expires: 7 });
					break;
				case 'email':
					Cookies.set('wordpress_captrust_utm_medium', 'Email', { expires: 7 });
					break;
				case 'search':
					Cookies.set('wordpress_captrust_utm_medium', 'Search', { expires: 7 });
					break;
				case 'social':
					Cookies.set('wordpress_captrust_utm_medium', 'Social', { expires: 7 });
					break;
				default:
					Cookies.set('wordpress_captrust_utm_medium', 'Ads', { expires: 7 });
					break;
			}
		} else if (!tracking.utm_medium && tracking.utm_source) {
			// Set fallback for utm_medium since it isn't always in the URL
			Cookies.set('wordpress_captrust_utm_medium', 'Ads', { expires: 7 });
		}
		
		// UTM Audience
		if (tracking.utm_audience) {
			Cookies.set('wordpress_captrust_utm_audience', captrustFormat(tracking.utm_audience), { expires: 7 });
		}

		// UTM Campaign
		if (tracking.utm_campaign) {
			Cookies.set('wordpress_captrust_utm_campaign', captrustFormat(tracking.utm_campaign), { expires: 7 });
		}

		// UTM Content
		if (tracking.utm_content) {
			Cookies.set('wordpress_captrust_utm_content', captrustFormat(tracking.utm_content), { expires: 7 });
		}
		
	}
	captrustTracking();
	

	/**
	 * Insert tracking cookie parameters into hidden fields for some Gravity Forms
	 * This is to get around the Pantheon edge caching that was submitting PANTHEON_STRIPPED in some cases when doing this with PHP Gravity Forms hooks
	 */
	function captrustFormTracking() {

		// GCLID - Read from localStorage (Google's recommended approach)
		// This runs on every page load to populate form fields with stored GCLID
		var gclidData = localStorage.getItem('gclid');
		if (gclidData) {
			try {
				var gclid = JSON.parse(gclidData);
				var isGclidValid = gclid && gclid.value && new Date().getTime() < gclid.expiryDate;
				if (isGclidValid) {
					$('#input_19_10, #input_21_10, #input_2_17, #input_3_26, #input_19_10').val(gclid.value);
					console.log('[Captrust Tracking] GCLID populated in form fields:', gclid.value);
				} else if (gclid && new Date().getTime() >= gclid.expiryDate) {
					// GCLID has expired - remove it
					localStorage.removeItem('gclid');
					console.log('[Captrust Tracking] GCLID expired and removed from localStorage');
				}
			} catch(e) {
				console.error('[Captrust Tracking] Error parsing GCLID from localStorage:', e);
			}
		}
		// MSCLKID
		if (Cookies.get('wordpress_captrust_msclkid')) {
			var value = decodeURIComponent(Cookies.get('wordpress_captrust_msclkid'));
			$('#input_2_25, #input_3_29, #input_19_11').val(value);
		}
		// UTM Audience
		if (Cookies.get('wordpress_captrust_utm_audience')) {
			var value = decodeURIComponent(Cookies.get('wordpress_captrust_utm_audience'));
			$('#input_2_18, #input_3_19, #input_19_15').val(value);
		}
		// UTM Campaign
		if (Cookies.get('wordpress_captrust_utm_campaign')) {
			var value = decodeURIComponent(Cookies.get('wordpress_captrust_utm_campaign'));
			$('#input_2_19, #input_3_20, #input_19_19').val(value);
		}
		// UTM Content
		if (Cookies.get('wordpress_captrust_utm_content')) {
			var value = decodeURIComponent(Cookies.get('wordpress_captrust_utm_content'));
			$('#input_2_20, #input_3_21, #input_19_18').val(value);
		}
		// UTM Medium
		if (Cookies.get('wordpress_captrust_utm_medium')) {
			var value = decodeURIComponent(Cookies.get('wordpress_captrust_utm_medium'));
			$('#input_2_21, #input_3_22, #input_19_17').val(value);
		}
		// UTM Source
		if (Cookies.get('wordpress_captrust_utm_source')) {
			var value = decodeURIComponent(Cookies.get('wordpress_captrust_utm_source'));
			$('#input_2_22, #input_3_23, #input_19_16').val(value);
		}

	}
	captrustFormTracking();


	/**
	 * Certain content needs to be adjusted/changed depending on which audience the user has been asociated with.
	 * Users submitting forms are assigned an audience depending on form selections.
	 * Users can also be assigned depending on a "user_audience" URL parameter that is being tracked in the captrustTracking function above
	 */
	function captrustDynamicContent() {


		// Get user audience (if there is one)
		if (Cookies.get('wordpress_captrust_visitor')) {

			var audience = JSON.parse(window.atob(Cookies.get('wordpress_captrust_visitor')));

			// Update people bio page content
			updateBioPageContent(audience.userAudience);
			// Update Tabbed Content Blocks
			updateTabbedContent(audience.userAudience);
			// Ajax profile modals
			$('.component-ajax-profile-modal').on('profileModalActive', function() {
				updateBioPageContent(audience.userAudience);
			});
			
		}


		function updateBioPageContent(audience) {

			var clients = $('.clients-include-list');

			if (clients.length) {

				var current_audience = '';

				switch(audience) {
					case 'endowments':
						current_audience = 'endowments-and-foundations';
						break;
					case 'individuals':
						current_audience = 'individuals';
						break;
					case 'retirement':
						current_audience = 'retirement-plan-sponsors';
						break;
				}

				clients.each(function() {
					// Find matching link
					var link = $(this).find('[data-audience="' + current_audience + '"]').first();
	
					if (link.length) {
						// Move link to first position
						link.prependTo($(this));
					}
				});

			}
		}


		function updateTabbedContent(audience) {

			var tab_title = '';

			switch(audience) {
				case 'endowments':
					tab_title = 'Endowment & Foundation Leaders';
					break;
				case 'individuals':
					tab_title = 'Individuals & Families';
					break;
				case 'retirement':
					tab_title = 'Retirement Plan Sponsors';
					break;
			}

			// Get all tabbed content blocks
			$('.block-tabbed-content').each(function() {
				
				// Find matching tab
				var tab = $(this).find('.component-tab-bar [data-tab-bar-target="' + tab_title + '"]').first();

				if (tab.length) {
					// Move tab to first position
					tab.prependTo(tab.closest('.component-tab-bar--tabs'));
					// Activate desired tab
					tab.trigger('click');
				}

				// Find matching dropdown
				var dropdown = $(this).find('.tabs-dropdown [data-tab-bar-target="' + tab_title + '"]').first();

				if (dropdown.length) {
					// Activate desired dropdown
					dropdown.prop('selected', true);
				}

			});

		}


	}
	captrustDynamicContent();

	
});